exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vc-link {\n  padding-top: 6px;\n  cursor: pointer; }\n\na:active {\n  background: #D9E4EA; }\n\n.btn-restore-points {\n  background-color: transparent;\n  color: #007cbb; }\n\n.title {\n  font-size: 14px;\n  padding: 0 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/deleted-vms/deleted-vms.scss
// module id = cQkg
// module chunks = 0